export type OrientationDegree = `${'' | '-'}${number}deg`;
export type GradientOrientation = 'vertical' | 'horizontal' | OrientationDegree;

function setGradientOrientation(color: string, orientation: GradientOrientation): string {
  let value: string;

  switch (orientation) {
    case 'vertical':
      value = '180deg';
      break;
    case 'horizontal':
      value = '90deg';
      break;
    default:
      value = orientation;
      break;
  }
  return color.replace(/90(\.0)?deg/g, value);
}

export default setGradientOrientation;
